/**
 * @format
 */
const CallHistoryView = () => import('@/views/voip/call-history-page');
const SharedCallsView = () => import('@/views/voip/shared-calls-page');

import store from '@/stores/index';

export default [
    // Client Voip Routes
    {
        path: '/Clients/:clientId/CallHistory',
        name: 'ClientCallHistory',
        component: CallHistoryView,
        meta: {
            type: 'client',
            subtype: 'voip',
            isUiShown: true,
            pageClass: 'client-call-history-view',
            pageTitle: 'Call History',
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        },
    },
    {
        path: '/Clients/:clientId/SharedCalls',
        name: 'SharedCalls',
        component: SharedCallsView,
        meta: {
            type: 'client',
            subtype: 'voip',
            isUiShown: true,
            pageClass: 'client-shared-calls-view',
            pageTitle: 'Shared Calls',
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        },
    },
];
